/**
 * am-kits-grid.js
 * Handles: filter tabs, kit drawer open/close, product fetch + render,
 * variant selection, deselect toggle, AJAX multi-item add-to-cart.
 */
(function () {
  'use strict';

  var kitProductCache = {};

  function productsFromKitCard(trigger) {
    var card = trigger && trigger.closest ? trigger.closest('.am-kits-grid__card') : null;
    if (!card) return null;
    var nodes = card.querySelectorAll('[data-kit-hotspot-handle]');
    if (!nodes.length) return null;
    var products = [];
    nodes.forEach(function (node, i) {
      var handle = node.getAttribute('data-kit-hotspot-handle');
      if (!handle) return;
      var letter = (node.getAttribute('data-kit-hotspot-letter') || '').trim();
      if (!letter) letter = String.fromCharCode(65 + (products.length % 26));
      products.push({
        handle: handle,
        letter: letter,
        color: node.getAttribute('data-kit-hotspot-color') || '',
        image: node.getAttribute('data-kit-hotspot-image') || null,
        variantId: node.getAttribute('data-kit-hotspot-variant-id') || null,
      });
    });
    return products;
  }

  function resolveKitProducts(trigger) {
    var fromCard = productsFromKitCard(trigger);
    if (fromCard && fromCard.length) return fromCard;
    var raw = (trigger && trigger.dataset.kitProducts) || '[]';
    try {
      return JSON.parse(raw);
    } catch (e) {
      return [];
    }
  }

  function indexKitHotspots(root) {
    if (!root) return;
    var hotspots = root.querySelectorAll('.am-shoppable-hotspot');
    hotspots.forEach(function (h, i) {
      h.setAttribute('data-am-hotspot-index', String(i));
      h.classList.toggle('am-shoppable-hotspot--active', i === 0);
      var letterEl = h.querySelector('.wt-dot__letter--auto');
      if (letterEl && !(letterEl.textContent || '').trim()) {
        letterEl.textContent = String.fromCharCode(65 + (i % 26));
      }
    });
    var slides = root.querySelectorAll('[data-am-slide-index]');
    slides.forEach(function (s, i) {
      s.setAttribute('data-am-slide-index', String(i));
      var n = slides.length;
      s.setAttribute('aria-label', 'Slide ' + (i + 1) + ' of ' + n);
      var card = root.closest('.am-kits-grid__card');
      if (card) s.setAttribute('data-block-id', card.getAttribute('data-block-id') || '');
    });
  }

  function indexAllKitHotspots(scope) {
    var roots = (scope || document).querySelectorAll('[data-am-shoppable-root]');
    roots.forEach(indexKitHotspots);
  }

  function prefetchKitProductsFromTrigger(trigger) {
    if (!trigger || trigger.dataset.amKitProductsPrefetched === 'true') return;
    trigger.dataset.amKitProductsPrefetched = 'true';

    var products = resolveKitProducts(trigger);
    products.forEach(function (p) {
      if (!p.handle || kitProductCache[p.handle]) return;
      fetch('/products/' + p.handle + '.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          kitProductCache[p.handle] = data;
        })
        .catch(function () {});
    });
  }

  function bindKitProductPrefetch() {
    document.querySelectorAll('.am-kits-grid__drawer-trigger').forEach(function (trigger) {
      if (trigger.dataset.amKitPrefetchBound === 'true') return;
      trigger.dataset.amKitPrefetchBound = 'true';

      trigger.addEventListener(
        'pointerenter',
        function () {
          prefetchKitProductsFromTrigger(trigger);
        },
        { once: true, passive: true },
      );
      trigger.addEventListener(
        'focus',
        function () {
          prefetchKitProductsFromTrigger(trigger);
        },
        { once: true },
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      indexAllKitHotspots();
      bindKitProductPrefetch();
    });
  } else {
    indexAllKitHotspots();
    bindKitProductPrefetch();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    indexAllKitHotspots(ev.target);
    bindKitProductPrefetch();
  });

  // ─── Scope ───────────────────────────────────────────────────────────────
  const bar = document.querySelector('[data-am-kits-bar]');
  if (!bar) return;

  (function initKitsCollectionBarStickyTop() {
    var stickyMq = window.matchMedia('(max-width: 899px)');
    var ticking = false;

    function updateStickyTop() {
      ticking = false;
      if (!stickyMq.matches) {
        document.documentElement.style.removeProperty('--collection-bar-sticky-top');
        return;
      }

      var header = document.querySelector(
        '#header.wt-header--amateur-custom, page-header#header',
      );
      var top = header
        ? Math.max(0, Math.round(header.getBoundingClientRect().bottom))
        : 0;
      document.documentElement.style.setProperty(
        '--collection-bar-sticky-top',
        top + 'px',
      );
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateStickyTop);
    }

    updateStickyTop();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateStickyTop, { passive: true });
    stickyMq.addEventListener('change', updateStickyTop);
  })();
  // The bar div also carries data-section-id, so use the <section> tag ancestor
  const SECTION_ID = bar.dataset.sectionId;
  const SECTION = bar.closest('section[data-section-id]') || bar.closest('.am-kits-grid-section');
  if (!SECTION) return;

  // ─── Elements ─────────────────────────────────────────────────────────────
  const grid      = SECTION.querySelector('[data-am-kits-grid]');
  const drawer    = SECTION.querySelector('[data-am-kits-drawer]');
  const countEl   = bar.querySelector('.am-kits-count');

  if (!grid || !drawer) return;

  // Move drawer to <body> so it's never trapped inside a transformed ancestor's stacking context
  document.body.appendChild(drawer);

  const drawerTitle    = drawer.querySelector('.am-kits-drawer__title');
  const drawerLoading  = drawer.querySelector('.am-kits-drawer__loading');
  const drawerProducts = drawer.querySelector('.am-kits-drawer__products');
  const drawerErrors   = drawer.querySelector('.am-kits-drawer__errors');
  const drawerAtc      = drawer.querySelector('.am-kits-drawer__atc');
  const SHOW_VENDOR    = String(drawer.dataset.showVendor || '') === 'true';

  // ─── Helpers ──────────────────────────────────────────────────────────────
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme?.moneyFormat ?? '${{amount}}');
    }
    return `$${(cents / 100).toFixed(2)}`;
  }

  /** Match cart drawer (`snippets/cart-item.liquid`): CDN `width` param + srcset for sharp thumbs. */
  var DRAWER_THUMB_WIDTHS = [640, 800, 1200, 1600];
  function sizedShopifyImageUrl(url, width) {
    if (!url || String(url).startsWith('data:')) return url || '';
    var w = String(width);
    try {
      var resolved = String(url).indexOf('//') === 0 ? 'https:' + url : url;
      var u = new URL(resolved);
      u.searchParams.set('width', w);
      return u.toString();
    } catch (e) {
      var sep = String(url).indexOf('?') >= 0 ? '&' : '?';
      return String(url) + sep + 'width=' + w;
    }
  }

  function applyDrawerProductThumb(img, baseUrl) {
    if (!baseUrl || String(baseUrl).startsWith('data:')) {
      img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
      img.style.background = '#f0f0f0';
      return;
    }
    img.style.background = '';
    const url1x = sizedShopifyImageUrl(baseUrl, 375);
    const url2x = sizedShopifyImageUrl(baseUrl, 750);
    img.src = url1x;
    img.srcset = `${url1x} 375w, ${url2x} 750w`;
    img.sizes = '(min-resolution: 2dppx) 750px, 375px';
    img.loading = 'eager';
    img.decoding = 'async';
  }

  const allCards = () => Array.from(grid.querySelectorAll('.am-kits-grid__card'));

  // ─── A. Filter logic ──────────────────────────────────────────────────────
  const tabs = Array.from(bar.querySelectorAll('[data-am-kits-tab]'));

  // Collection bar: when pills fit exactly in the track, native overflow scroll has no range.
  // Nudge intrinsic width so the row can scroll horizontally on small screens.
  (() => {
    try {
      const track = bar.querySelector('.am-collection-bar__pills-track');
      if (!track) return;
      requestAnimationFrame(() => {
        if (track.scrollWidth <= track.clientWidth) {
          track.style.paddingRight = '64px';
          track.style.boxSizing = 'content-box';
        }
      });
    } catch (e) {}
  })();

  function updateCount() {
    if (!countEl) return;
    const visible = allCards().filter(c => c.style.display !== 'none').length;
    countEl.textContent = `(${visible})`;
  }

  function activateTab(tab) {
    const target = tab.dataset.amKitsTab;
    tabs.forEach(t => t.classList.toggle('am-collection-bar__pill--active', t === tab));
    allCards().forEach(card => {
      card.style.display = (target === 'all' || card.dataset.category === target) ? '' : 'none';
    });
    updateCount();
  }

  tabs.forEach(tab => tab.addEventListener('click', () => activateTab(tab)));

  // ─── B. Drawer open ───────────────────────────────────────────────────────
  async function openDrawer(trigger) {
    prefetchKitProductsFromTrigger(trigger);

    const kitName     = trigger.dataset.kitName || '';
    const kitUrl      = trigger.dataset.kitUrl  || '';
    const products    = resolveKitProducts(trigger);

    // Set header
    drawerTitle.textContent = kitName;

    drawerErrors.textContent = '';
    drawerErrors.style.display = 'none';
    setDrawerAtcLoading(false);
    setDrawerAtcLabel(drawerAtcDefaultLabel());

    drawerProducts.innerHTML = '';
    products.forEach(function (p) {
      drawerProducts.appendChild(
        buildProductRow({
          handle: p.handle,
          __letter: p.letter,
          __image: p.image || null,
          __color: p.color || null,
          __variantId: p.variantId || null,
        })
      );
    });

    // Open
    drawer.classList.add('am-kits-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    if (products.length === 0) {
      drawerProducts.innerHTML = '<p style="padding:20px;font-size:13px;opacity:.6">No products found for this kit.</p>';
      return;
    }

    var fetchPromise = Promise.all(
      products.map(function (p) {
        if (kitProductCache[p.handle]) {
          var cachedRow = Object.assign({}, kitProductCache[p.handle]);
          cachedRow.__letter = p.letter;
          cachedRow.__image = p.image || null;
          cachedRow.__color = p.color || null;
          cachedRow.__variantId = p.variantId || null;
          return Promise.resolve(cachedRow);
        }
        return fetch('/products/' + p.handle + '.js')
          .then(function (r) {
            if (!r.ok) throw new Error(`Product not found: ${p.handle}`);
            return r.json();
          })
          .then(function (data) {
            kitProductCache[p.handle] = data;
            var row = Object.assign({}, data);
            row.__letter = p.letter;
            row.__image = p.image || null;
            row.__color = p.color || null;
            row.__variantId = p.variantId || null;
            return row;
          });
      })
    );

    fetchPromise
      .then(function (productDataList) {
        productDataList.forEach(function (product) {
          const row = drawerProducts.querySelector(
            `[data-product-handle="${product.handle}"]`
          );
          if (row) hydrateProductRow(row, product);
        });
      })
      .catch(function (err) {
        showDrawerError('Could not load kit products. Please try again.');
        console.error('[am-kits-grid] fetch error:', err);
      });
  }

  function setLoading(on) {
    drawerLoading.classList.toggle('am-kits-drawer__loading--active', on);
    if (drawerAtc) drawerAtc.disabled = on;
  }

  // ─── C. Render product rows ───────────────────────────────────────────────
  function renderProducts(products) {
    drawerProducts.innerHTML = '';
    products.forEach(product => drawerProducts.appendChild(buildProductRow(product)));
  }

  function buildVariantsSection(row, product) {
    const optionNames = (product.options || []).map(o => (typeof o === 'string' ? o : o.name));
    const isSingleDefaultVariant = optionNames.length === 1 && optionNames[0] === 'Title';

    if (!product.variants || product.variants.length === 0) return null;
    if (!(optionNames.length > 0 && !isSingleDefaultVariant)) return null;

    const variantWrap = document.createElement('div');
    variantWrap.className = 'am-kits-product-row__variants';

    optionNames.forEach((optName, optIdx) => {
      const values = getOptionValues(product, optIdx);
      if (!values.length) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'am-kits-custom-select';
      wrapper.setAttribute('aria-label', optName);
      wrapper.dataset.optionIndex = optIdx;
      wrapper.dataset.value = '';

      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'am-kits-custom-select__trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.innerHTML = `<span class="am-kits-custom-select__label">Select ${optName}</span>`;

      const listbox = document.createElement('ul');
      listbox.className = 'am-kits-custom-select__listbox';
      listbox.setAttribute('role', 'listbox');
      listbox.setAttribute('aria-label', optName);

      values.forEach(v => {
        const li = document.createElement('li');
        li.className = 'am-kits-custom-select__option';
        if (!v.available) li.classList.add('am-kits-option--soldout');
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        li.setAttribute('aria-disabled', v.available ? 'false' : 'true');
        li.dataset.value = v.value;
        li.textContent = v.available ? v.value : `${v.value} — Sold Out`;

        li.addEventListener('click', () => {
          if (!v.available) return;
          listbox.querySelectorAll('.am-kits-custom-select__option').forEach(o => {
            o.setAttribute('aria-selected', 'false');
            o.classList.remove('am-kits-custom-select__option--selected');
          });
          li.setAttribute('aria-selected', 'true');
          li.classList.add('am-kits-custom-select__option--selected');
          trigger.querySelector('.am-kits-custom-select__label').textContent = v.value;
          wrapper.dataset.value = v.value;
          closeDropdown(wrapper);
          updateSelectedVariant(row, row._amKitsProduct);
        });

        listbox.appendChild(li);
      });

      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = wrapper.classList.contains('am-kits-custom-select--open');
        drawer.querySelectorAll('.am-kits-custom-select--open').forEach(d => closeDropdown(d));
        if (!isOpen) openDropdown(wrapper);
      });

      wrapper.appendChild(trigger);
      wrapper.appendChild(listbox);
      variantWrap.appendChild(wrapper);
    });

    return variantWrap;
  }

  function preselectVariantOptions(row, product, variant) {
    if (!variant) return;

    row.querySelectorAll('.am-kits-custom-select').forEach(wrapper => {
      const optIdx = parseInt(wrapper.dataset.optionIndex, 10);
      const val = variant[`option${optIdx + 1}`];
      if (!val) return;

      const li = Array.from(wrapper.querySelectorAll('.am-kits-custom-select__option')).find(
        o => o.dataset.value === val && o.getAttribute('aria-disabled') !== 'true',
      );
      if (!li) return;

      wrapper.querySelectorAll('.am-kits-custom-select__option').forEach(o => {
        o.setAttribute('aria-selected', 'false');
        o.classList.remove('am-kits-custom-select__option--selected');
      });
      li.setAttribute('aria-selected', 'true');
      li.classList.add('am-kits-custom-select__option--selected');

      const label = wrapper.querySelector('.am-kits-custom-select__label');
      if (label) label.textContent = val;
      wrapper.dataset.value = val;
    });

    updateSelectedVariant(row, product);
  }

  function hydrateProductRow(row, product) {
    row._amKitsProduct = product;
    if (product.id) row.dataset.productId = String(product.id);

    const img = row.querySelector('.am-kits-product-row__img');
    if (img) {
      if (product.title) img.alt = product.title;
      const thumbUrl = product.__image || product.featured_image || product.images?.[0];
      applyDrawerProductThumb(img, thumbUrl);
    }

    const nameEl = row.querySelector('.am-kits-product-row__name');
    if (nameEl && product.title) nameEl.textContent = String(product.title).toLowerCase();

    if (SHOW_VENDOR && product.vendor) {
      const body = row.querySelector('.am-kits-product-row__body');
      let vendorEl = row.querySelector('.am-kits-product-row__vendor');
      if (!vendorEl && body) {
        vendorEl = document.createElement('div');
        vendorEl.className = 'am-kits-product-row__vendor';
        const name = row.querySelector('.am-kits-product-row__name');
        body.insertBefore(vendorEl, name || row.querySelector('[data-price-display]'));
      }
      if (vendorEl) vendorEl.textContent = product.vendor;
    }

    const firstVariant = product.variants?.[0];
    const priceEl = row.querySelector('[data-price-display]');
    if (priceEl && firstVariant) priceEl.textContent = formatMoney(firstVariant.price);

    const placeholder = row.querySelector('.am-kits-product-row__variants-placeholder');
    if (placeholder) {
      const variantSection = buildVariantsSection(row, product);
      if (variantSection) {
        placeholder.replaceWith(variantSection);
        if (product.__variantId) {
          const pinnedVariant = (product.variants || []).find(
            v => String(v.id) === String(product.__variantId),
          );
          if (pinnedVariant) preselectVariantOptions(row, product, pinnedVariant);
        }
      } else {
        placeholder.remove();
        if (product.__variantId) {
          row.dataset.selectedVariantId = String(product.__variantId);
        } else if (firstVariant) {
          row.dataset.selectedVariantId = String(firstVariant.id);
        }
      }
    } else if (product.__variantId) {
      const pinnedVariant = (product.variants || []).find(
        v => String(v.id) === String(product.__variantId),
      );
      if (pinnedVariant) preselectVariantOptions(row, product, pinnedVariant);
    }
  }

  function buildProductRow(product) {
    const row = document.createElement('div');
    row.className = 'am-kits-product-row am-kits-product-row--selected';
    row._amKitsProduct = product;
    if (product.id) row.dataset.productId = String(product.id);
    if (product.handle) row.dataset.productHandle = product.handle;
    row.dataset.selectedVariantId = product.variants?.[0] ? String(product.variants[0].id) : '';

    // Image (responsive CDN URLs — same idea as `snippets/cart-item.liquid`)
    const img = document.createElement('img');
    img.className = 'am-kits-product-row__img';
    img.alt = product.title || '';
    const thumbUrl = product.__image || product.featured_image || product.images?.[0];
    applyDrawerProductThumb(img, thumbUrl);
    row.appendChild(img);

    // Body
    const body = document.createElement('div');
    body.className = 'am-kits-product-row__body';

    if (product.__letter) {
      const letter = document.createElement('div');
      letter.className = 'am-kits-product-row__letter';
      letter.textContent = product.__letter;
      body.appendChild(letter);
    }

    if (SHOW_VENDOR && product.vendor) {
      const vendorEl = document.createElement('div');
      vendorEl.className = 'am-kits-product-row__vendor';
      vendorEl.textContent = product.vendor;
      body.appendChild(vendorEl);
    }

    const name = document.createElement('div');
    name.className = 'am-kits-product-row__name';
    name.textContent = product.title ? String(product.title).toLowerCase() : '';
    body.appendChild(name);

    const priceEl = document.createElement('div');
    priceEl.className = 'am-kits-product-row__price';
    priceEl.dataset.priceDisplay = '';
    const firstVariant = product.variants?.[0];
    priceEl.textContent = firstVariant ? formatMoney(firstVariant.price) : '';
    body.appendChild(priceEl);

    if (!product.variants || product.variants.length === 0) {
      const placeholder = document.createElement('div');
      placeholder.className = 'am-kits-product-row__variants-placeholder';
      body.appendChild(placeholder);
    } else {
      const variantSection = buildVariantsSection(row, product);
      if (variantSection) {
        body.appendChild(variantSection);
      } else if (firstVariant) {
        row.dataset.selectedVariantId = String(firstVariant.id);
      }
    }

    // Inline error
    const rowError = document.createElement('div');
    rowError.className = 'am-kits-product-row__error';
    rowError.style.display = 'none';
    body.appendChild(rowError);

    row.appendChild(body);

    // Deselect toggle (top-right)
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'am-kits-product-row__toggle';
    toggle.setAttribute('aria-pressed', 'true');
    toggle.innerHTML =
      '<svg viewBox="0 0 72 72" fill="currentColor" aria-hidden="true" focusable="false">' +
        '<path d="m58.55199,15.95408l-10.85873,0l-3.50748,-4.69075a5.01211,5.01211 0 0 0 -4.01068,-1.99289l-8.35268,0a5.01211,5.01211 0 0 0 -4.01566,1.99289l-3.5025,4.69075l-10.85873,0a0.83452,0.83452 0 0 0 -0.83452,0.83452l0,1.67153a0.83452,0.83452 0 0 0 0.83452,0.83452l2.50605,0l0,38.42283a5.01211,5.01211 0 0 0 5.01211,5.01211l30.07264,0a5.01211,5.01211 0 0 0 5.01211,-5.01211l0,-38.42283l2.50605,0a0.83452,0.83452 0 0 0 0.83452,-0.83452l0,-1.67153a0.83452,0.83452 0 0 0 -0.83701,-0.83452zm-28.06481,-2.67296a1.6815,1.6815 0 0 1 1.33772,-0.66762l8.35268,0a1.6815,1.6815 0 0 1 1.33772,0.66762l1.99289,2.67296l-15.02635,0l2.00534,-2.67296zm22.23063,44.43636a1.67153,1.67153 0 0 1 -1.67153,1.67153l-30.0826,0a1.67153,1.67153 0 0 1 -1.67153,-1.67153l0,-38.42283l33.42567,0l0,38.42283z"/>' +
      '</svg>';

    toggle.addEventListener('click', () => {
      row.style.transition = 'opacity 0.2s ease';
      row.style.opacity = '0';
      setTimeout(() => row.remove(), 200);
    });

    row.appendChild(toggle);
    return row;
  }

  function getOptionValues(product, optIdx) {
    const seen = {};
    const values = [];
    (product.variants || []).forEach(v => {
      const val = v[`option${optIdx + 1}`];
      if (!val) return;
      if (!seen[val]) {
        seen[val] = { value: val, available: false };
        values.push(seen[val]);
      }
      if (v.available) seen[val].available = true;
    });
    return values;
  }

  // ─── D. Variant selection ─────────────────────────────────────────────────
  function updateSelectedVariant(row, product) {
    const selects = Array.from(row.querySelectorAll('.am-kits-custom-select'));
    const selectedOptions = selects.map(s => s.dataset.value || '');

    const match = (product.variants || []).find(v =>
      selectedOptions.every((val, i) => !val || v[`option${i + 1}`] === val)
    );

    if (match) {
      row.dataset.selectedVariantId = String(match.id);
      const priceEl = row.querySelector('[data-price-display]');
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      clearRowError(row);
    } else {
      row.dataset.selectedVariantId = '';
    }
  }

  // ─── E. Add to cart ───────────────────────────────────────────────────────
  // Cart-drawer element — mirrors product-form.js approach to avoid double-render
  const cartDrawerEl = document.querySelector('cart-drawer');

  function setDrawerAtcLabel(text) {
    if (!drawerAtc) return;
    const label = drawerAtc.querySelector('.am-kits-drawer__atc-label');
    if (label) label.textContent = text;
    else drawerAtc.textContent = text;
  }

  function setDrawerAtcLoading(loading) {
    if (!drawerAtc) return;
    const spin = drawerAtc.querySelector('.loading-overlay__spinner');
    if (loading) {
      drawerAtc.classList.add('loading');
      if (spin) spin.classList.remove('hidden');
    } else {
      drawerAtc.classList.remove('loading');
      if (spin) spin.classList.add('hidden');
    }
  }

  function drawerAtcDefaultLabel() {
    return drawerAtc?.getAttribute('data-am-atc-default') || 'Add to Cart';
  }

  if (drawerAtc) {
    drawerAtc.addEventListener('click', async () => {
      const rows = Array.from(drawerProducts.querySelectorAll('.am-kits-product-row'));
      const selectedRows = rows.filter(r => r.classList.contains('am-kits-product-row--selected'));

      if (!selectedRows.length) {
        showDrawerError('Please select at least one product.');
        return;
      }

      let hasError = false;
      selectedRows.forEach(row => {
        const hasSelects = row.querySelectorAll('.am-kits-custom-select').length > 0;
        if (hasSelects) {
          const allChosen = Array.from(row.querySelectorAll('.am-kits-custom-select'))
            .every(s => s.dataset.value !== '');
          if (!allChosen || !row.dataset.selectedVariantId) {
            showRowError(row, 'Please select all options.');
            hasError = true;
          }
        }
      });
      if (hasError) return;

      const items = selectedRows.map(row => ({
        id: parseInt(row.dataset.selectedVariantId, 10),
        quantity: 1,
      }));

      drawerAtc.disabled = true;
      setDrawerAtcLoading(true);
      drawerErrors.style.display = 'none';
      drawerErrors.textContent = '';

      // Build sections list the same way product-form.js does so Shopify returns
      // pre-rendered section HTML — this lets us call renderContents() directly
      // and avoids the CartDrawerItems.onCartUpdate() path which injects cart-page
      // HTML into the drawer and creates duplicate headers/shipping bars.
      let sectionsParam = '';
      if (cartDrawerEl && typeof cartDrawerEl.getSectionsToRender === 'function') {
        sectionsParam = cartDrawerEl.getSectionsToRender().map(s => s.id).join(',');
      }

      const payload = { items };
      if (sectionsParam) payload.sections = sectionsParam;
      if (window.location?.pathname) payload.sections_url = window.location.pathname;

      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload),
        });
        if (!r.ok) {
          const d = await r.json();
          throw new Error(d.description || 'Cart error');
        }
        const response = await r.json();

        drawerAtc.disabled = false;
        setDrawerAtcLoading(false);
        setDrawerAtcLabel(drawerAtcDefaultLabel());
        closeDrawer();
        // Use cart-drawer's own renderContents — identical to product-form.js success path.
        // isClosedCart=true so the theme cart drawer opens after ATC.
        if (cartDrawerEl && typeof cartDrawerEl.renderContents === 'function' && response.sections) {
          cartDrawerEl.renderContents(response, true);
        } else {
          // Fallback: dispatch cart-drawer:refresh so the drawer section re-fetches
          // its own HTML (correct structure, no main-cart-items injection).
          document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { bubbles: true }));
        }
      } catch (err) {
        drawerAtc.disabled = false;
        setDrawerAtcLoading(false);
        setDrawerAtcLabel(drawerAtcDefaultLabel());
        showDrawerError(err.message || 'Something went wrong. Please try again.');
        console.error('[am-kits-grid] add-to-cart error:', err);
      }
    });
  }

  // ─── F. Drawer close ──────────────────────────────────────────────────────
  function closeDrawer() {
    drawer.classList.remove('am-kits-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  drawer.querySelectorAll('[data-am-kits-drawer-close]').forEach(el =>
    el.addEventListener('click', closeDrawer)
  );

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawer.classList.contains('am-kits-drawer--open')) closeDrawer();
  });

  document.addEventListener('click', () => {
    drawer.querySelectorAll('.am-kits-custom-select--open').forEach(d => closeDropdown(d));
  });

  // ─── Error helpers ─────────────────────────────────────────────────────────
  function showDrawerError(msg) {
    drawerErrors.textContent = msg;
    drawerErrors.style.display = 'block';
  }

  function showRowError(row, msg) {
    const el = row.querySelector('.am-kits-product-row__error');
    if (el) { el.textContent = msg; el.style.display = 'block'; }
  }

  function clearRowError(row) {
    const el = row.querySelector('.am-kits-product-row__error');
    if (el) { el.textContent = ''; el.style.display = 'none'; }
  }

  function openDropdown(wrapper) {
    wrapper.classList.add('am-kits-custom-select--open');
    wrapper.querySelector('.am-kits-custom-select__trigger').setAttribute('aria-expanded', 'true');
  }

  function closeDropdown(wrapper) {
    wrapper.classList.remove('am-kits-custom-select--open');
    wrapper.querySelector('.am-kits-custom-select__trigger').setAttribute('aria-expanded', 'false');
  }

  // ─── Drawer trigger click delegation ──────────────────────────────────────
  // Listen on document so drawer triggers work even when nested in sticky overlays.
  document.addEventListener('click', e => {
    const trigger = e.target.closest('.am-kits-grid__drawer-trigger');
    if (!trigger) return;
    // Ignore triggers that belong to a different section instance
    if (trigger.dataset.amKitsSection && trigger.dataset.amKitsSection !== SECTION_ID) return;
    openDrawer(trigger);
  });

  // ─── Theme Editor: re-init filter state on section reload ─────────────────
  document.addEventListener('shopify:section:load', e => {
    if (!e.target.contains(bar)) return;
    updateCount();
    const activeTab = bar.querySelector('.am-collection-bar__pill--active');
    if (activeTab) activateTab(activeTab);
  });

})();
